import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — accessible + emits BreadcrumbList JSON-LD for Google.
 * items: [{ label: 'Home', to: '/' }, { label: 'Guide', to: '/guide' }, { label: 'Titolo' }]
 * Last item has no `to` and represents the current page.
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `https://www.spectrumservice.it${it.to}` } : {}),
    })),
  };
  return (
    <>
      <nav
        data-testid="breadcrumbs"
        aria-label="Breadcrumb"
        className="max-w-5xl mx-auto px-4 sm:px-8 pt-6 text-[11px] font-mono uppercase tracking-widest text-zinc-500"
      >
        <ol className="flex flex-wrap items-center gap-1.5">
          {items.map((it, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {it.to ? (
                <Link to={it.to} className="hover:text-rose-400 transition">
                  {it.label}
                </Link>
              ) : (
                <span className="text-zinc-300">{it.label}</span>
              )}
              {i < items.length - 1 && (
                <ChevronRight size={12} className="text-zinc-700" />
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
